module.exports = __webpack_public_path__ + "assets/media/iphone-img.cff58a83.jpg";